import { Credential } from '../Types';
import { SaveCredential } from '../Types/ServiceTypes';
import requestClient from '../components/Utility/RequestClient';
import { StoreEnvironment } from '../Types/StoreTypes';
import { store } from '../store';

const resolveDemo = () => (store.getState().environment as StoreEnvironment).demoInstance;

export const credentialsService = {
    getCredentials: (): Promise<{ data: { data: Credential[] } }> => {
        const demo = resolveDemo();
        return requestClient
            .get<{ data: Credential[] }>(`${demo ? '/demo' : ''}/credentials/get`)
            .then((response: any) => response);
    },

    getCredentialsByPage: (
        page: number,
        itemsPerPage: number,
        additionalParams?: Record<string, any>,
        query?: string | null,
    ): Promise<{ data: { data: Credential[]; total: number } }> => {
        return requestClient
            .get<{ data: Credential[]; total: number }>(`${resolveDemo() ? '/demo' : ''}/credentials/get`, {
                params: {
                    page,
                    itemsPerPage,
                    query,
                },
            })
            .then((response: any) => response);
    },

    getCredential: async (demo: boolean, identifier: string): Promise<{ data: Credential }> => {
        return requestClient.get<Credential>(`${demo ? '/demo' : ''}/credentials/get/${identifier}`);
    },

    saveCredential: async (type: string, data: SaveCredential): Promise<any> => {
        return requestClient.post<Credential>(`/credentials/${type}`, data);
    },

    deleteCredential: async (identifier: string): Promise<any> => {
        return requestClient.delete(`/credentials/delete/${identifier}`);
    },
};
